import { DocumentPickerAsset } from "expo-document-picker";

/**
 * Converts a base64 PNG data URL to a DocumentPickerAsset
 * @param base64Data - Base64 PNG data URL (e.g., "data:image/png;base64,...")
 * @param fileName - Optional custom file name (defaults to signature-{timestamp}.png)
 * @returns DocumentPickerAsset compatible object
 */
export function base64ToDocumentPickerAsset(
  base64Data: string,
  fileName?: string,
): DocumentPickerAsset {
  // Generate a unique filename if not provided
  const timestamp = Date.now();
  const name = fileName || `signature-${timestamp}.png`;

  // Convert base64 to blob
  const base64WithoutPrefix = base64Data.split(",")[1];
  const byteString = atob(base64WithoutPrefix || "");
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uint8Array = new Uint8Array(arrayBuffer);

  for (let i = 0; i < byteString.length; i++) {
    uint8Array[i] = byteString.charCodeAt(i);
  }

  const blob = new Blob([uint8Array], { type: "image/png" });

  // Create a File object from the blob
  const file = new File([blob], name, { type: "image/png" });

  // Create object URL for the file
  const uri = URL.createObjectURL(blob);

  // Return DocumentPickerAsset compatible object
  return {
    uri,
    name,
    size: blob.size,
    mimeType: "image/png",
    file,
  } as DocumentPickerAsset;
}
